import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import deviceSelect from '@blade/common/components/device-cascader-select/index.vue';
// import ResultPage from '@blade-sxp/data-mining/pages/companions/components/components-right/result-page.vue';
// import Popover from '@blade-sxp/search-center/pages/components/result/popover';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
let DataMining = class DataMining extends Vue {
    show;
    allNum;
    selectedImg;
    isChecked;
    tagList;
    resultType; // 判断任务结果类型
    isRoute; // 判断是否展示轨迹按钮
    disabled; // 判断是否禁用轨迹按钮
    form = {
        dates: [],
        device: [],
    };
    openCheck = true;
    maxHeight = 203;
    routeImageUrl = require('@blade-sxp/search-center/assets/images/route.png');
    deleteImageUrl = require('@blade-sxp/search-center/assets/images/del.png');
    isShow = false;
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    // 没有轨迹不可点击
    get getDisabled() {
        if (!this.allNum) {
            return true;
        }
        return false;
    }
    mounted() {
        window.addEventListener('scroll', this.handleScrollx, true);
    }
    handleScrollx(e) {
        const elm = e.target;
        if (elm?.className === 'main-container') {
            this.isShow = false;
        }
    }
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScrollx, true);
    }
    route() {
        this.openCheck = !this.openCheck;
        this.$emit('selectable', this.openCheck);
    }
    tagShow() {
        this.$emit('filter');
    }
    // 触发hover弹框
    showPopover() {
        this.$emit('show-popover');
    }
    // 清空全部轨迹
    clearAlltrack() {
        this.$emit('clear-alltrack');
    }
    // 删除一个轨迹
    deleteImg(imageId, item) {
        this.$emit('delete-img', imageId, item);
    }
    openTrack() {
        this.$emit('open-track');
    }
};
__decorate([
    Prop()
], DataMining.prototype, "show", void 0);
__decorate([
    Prop({ default: 0 })
], DataMining.prototype, "allNum", void 0);
__decorate([
    Prop()
], DataMining.prototype, "selectedImg", void 0);
__decorate([
    Prop()
], DataMining.prototype, "isChecked", void 0);
__decorate([
    Prop()
], DataMining.prototype, "tagList", void 0);
__decorate([
    Prop()
], DataMining.prototype, "resultType", void 0);
__decorate([
    Prop({ default: true })
], DataMining.prototype, "isRoute", void 0);
__decorate([
    Prop({ default: false })
], DataMining.prototype, "disabled", void 0);
DataMining = __decorate([
    Component({
        name: 'right',
        components: { deviceSelect, BlurPicture },
        i18n: {
            messages: {
                en: {
                    reset: 'Reset',
                    device: 'device',
                    ok: 'OK',
                    route: 'route',
                    developRoute: 'Generate Route',
                },
                zh: {
                    reset: '重置',
                    device: '设备',
                    ok: '确定',
                    route: '轨迹',
                    developRoute: '轨迹还原',
                },
            },
        },
    })
], DataMining);
export default DataMining;
